const DYNAMICS_FIELDS = {
    generalData: "bdp_ms_frmgeneraldata",
    metaData: "bdp_ms_frmmetadata",
    formData: "bdp_ms_frmformdata",
    leadsourcecode: "leadsourcecode",
} as const;

const DYNAMICS_FORM_API_URL = process.env.GATSBY_DYNAMICS_FORM_API_URL;

export { DYNAMICS_FORM_API_URL, DYNAMICS_FIELDS };
